import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import Appconfig from '../config/config'; // Adjust path as needed
import { setUserInfo } from '../redux/slice/userInfo/userInfoSlice'; // Adjust path
import { getNews } from '../redux/slice/news/newsSlice'; // Adjust path

export const useLoginLogic = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // State
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    
    // Validation Errors
    const [user_nameValidationError, setUserNameValidationError] = useState("");
    const [passwordValidationError, setPasswordValidationError] = useState("");
    const [captchaValidationError, setCaptchaValidationError] = useState("");
    const [validationError, setValidationError] = useState(""); // General error

    // Captcha State
    const [captcha, setCaptcha] = useState("");
    const [captchaInput, setCaptchaInput] = useState("");

    const [formData, setformData] = useState({
        user_name: '',
        password: '',
        site_code: Appconfig.sitecodes,
        user_type: "User" 
    });

    // Generate Captcha
    const generateCaptchaCode = () => {
        const randomCode = Math.floor(1000 + Math.random() * 9000).toString();
        setCaptcha(randomCode);
        setCaptchaInput("");
        setCaptchaValidationError("");
        setValidationError("");
    };

    useEffect(() => {
        generateCaptchaCode();
    }, []);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleInputChange = (event) => {
        setformData({
            ...formData,
            [event.target.name]: event.target.value
        });
        // Clear errors on type
        if(event.target.name === 'user_name') setUserNameValidationError("");
        if(event.target.name === 'password') setPasswordValidationError("");
        setValidationError("");
    };

    const checkValidation = () => {
        setUserNameValidationError("");
        setPasswordValidationError("");
        setCaptchaValidationError("");
        let isValid = true;

        if (formData.user_name.trim() === "") {
            setUserNameValidationError('Enter username');
            isValid = false;
        }
        
        const regex = /^[a-zA-Z0-9]*$/;
        if (!regex.test(formData.user_name)) {
            setUserNameValidationError('Only a-z and 0-9 allowed.');
            isValid = false;
        }

        if (formData.password === "") {
            setPasswordValidationError('Enter password');
            isValid = false;
        }

        if (captchaInput !== captcha) {
            setCaptchaValidationError("Invalid Code");
            isValid = false;
        }

        return isValid;
    };

    // --- UPDATED HANDLESUBMIT ---
    // Now accepts an optional 'onSuccess' callback
    const handleSubmit = (event, onSuccess) => {
        if(event) event.preventDefault();
        
        if (checkValidation()) {
            setIsDisabled(true);
            setIsLoading(true);

            var config = {
                method: 'post',
                url: `${Appconfig.apiUrl}users/userAuthenticate`,
                headers: { 'Content-Type': 'application/json' },
                data: JSON.stringify(formData)
            };

            axios(config)
                .then(function (response) {
                    setIsDisabled(false);
                    setIsLoading(false);

                    if (response.data.result !== 0) {
                        NotificationManager.success(response.data.resultMessage, '', 3000);
                        
                        // Redux updates
                        dispatch(getNews({ site_id: Appconfig.superAdmin }));
                        dispatch(setUserInfo(response.data.resultData));
                        
                        // LocalStorage updates
                        localStorage.setItem("loginTime", new Date().getTime().toString());
                        localStorage.setItem('login_token', response.data.resultData?.login_token);
                        
                        // --- EXECUTE CALLBACK IF PROVIDED ---
                        if (onSuccess && typeof onSuccess === 'function') {
                            onSuccess();
                        }
                        // ------------------------------------

                        setTimeout(() => {
                            navigate('/');
                        }, 1000);
                    } else {
                        setValidationError(response.data.resultMessage);
                        NotificationManager.error(response.data.resultMessage, '', 3000);
                        generateCaptchaCode(); 
                    }
                })
                .catch(function (error) {
                    setIsDisabled(false);
                    setIsLoading(false);
                    console.log(error);
                });
        }
    };

    return {
        formData,
        handleInputChange,
        handleSubmit, // This now supports (e, onSuccess)
        isLoading,
        isDisabled,
        showPassword,
        togglePasswordVisibility,
        // Captcha
        captcha,
        captchaInput,
        setCaptchaInput,
        generateCaptchaCode,
        // Errors
        validationError,
        user_nameValidationError,
        passwordValidationError,
        captchaValidationError
    };
};